@if (canSwitchOutput && shouldDisplayArrows()) {
  <div class="tag-label-container">
    <a (click)="switchOutputTo('left')">
      <mat-icon fontIcon="chevron_left">chevron_left</mat-icon>
    </a>

    <div class="caption">{{ outputName }}</div>
    <a (click)="switchOutputTo('right')">
      <mat-icon fontIcon="chevron_right"></mat-icon>
    </a>
  </div>
} @else {
  <div class="caption">{{ outputName }}</div>
}
